import React, { useContext } from 'react';
import NavbarKey from '../components/nav/NavBarKey'
import UserProvider from '../context/UserContext'
import { Toaster } from 'react-hot-toast';

import _ from "lodash";
import { MainSuccess } from '../components/mains/MainSuccess'
import { MainBanned } from '../components/mains/MainBanned'
import { MainExistingMember } from '../components/mains/MainExistingMember'
import { MainWaitlist } from '../components/mains/MainWaitlist'
import { Footer } from '../components/footer/Footer';


export const Waitlist = () => {
    var Context = useContext(UserProvider.context);
    const userData = Context.user
    const Logged = !_.isEmpty(userData);
    const isWaitlisted = Context.waitlisted;
    const isUser = Context.is_user;
    const isLoaded = !(Context.loading);
    const isBanned = Context.banned

    return (
        <div className="parent">
            {
                isLoaded && 
                Logged &&
                isBanned &&
                <div className="parent">
                    <div>
                        <NavbarKey></NavbarKey>
                    </div>
                    <div className="column-main">
                        <MainBanned/>
                    </div>
                    <Footer/>
                </div>
            }
            {
                isLoaded && 
                Logged &&
                isUser &&
                !isBanned && 
                <div className="parent">
                    <div>
                        <NavbarKey></NavbarKey>
                    </div>
                    <div className="column-main">
                        <MainExistingMember/>
                    </div>
                    <Footer/>
                </div>
            }
            {
                isLoaded && 
                Logged &&
                isWaitlisted &&
                !isUser &&
                !isBanned &&
                <div className="parent">
                    <div>
                        <NavbarKey></NavbarKey>
                    </div>
                    <div className="column-main">
                        <MainSuccess/>
                    </div>
                    <Footer/>
                </div>
            }
            {
                isLoaded && 
                Logged &&
                !isWaitlisted &&
                !isUser &&
                !isBanned &&
                <div className="parent">
                    <div>
                        <NavbarKey></NavbarKey>
                    </div>
                    <div className="column-main container">
                        <MainWaitlist/>
                    </div>
                    <Footer/>
                </div>
            }
            {
                isLoaded && 
                !Logged &&
                window.location.replace(`${process.env.REACT_APP_API_URL}/discord-auth/`)
            }
            <Toaster
            toastOptions={{
                style: {
                  marginTop: '50px'
                },
              }}
            />
        </div>
    )
};